import { shape, string } from 'prop-types';

export const FEATURE_LOGO_OVERLAY_IMAGE = shape({
    default: string,
    small: string,
    middle: string,
    large: string,
});
